import { render, staticRenderFns } from "./CollaboratorListCell.vue?vue&type=template&id=ce8c5b64&scoped=true"
import script from "./CollaboratorListCell.vue?vue&type=script&lang=js"
export * from "./CollaboratorListCell.vue?vue&type=script&lang=js"
import style0 from "./CollaboratorListCell.vue?vue&type=style&index=0&id=ce8c5b64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8c5b64",
  null
  
)

export default component.exports